import { FeatureFlags } from '~/modules/feature_flags';

export function canSendFilterEngagement(): boolean {
    const summaryFlag = FeatureFlags.FF_ACE_ENABLE_AI_LISTINGS_SUMMARY;
    const eventsFlag = FeatureFlags.FF_ACE_ENABLE_AI_LISTINGS_SUMMARY_ANALYTICS_EVENTS;
    return summaryFlag && eventsFlag;
}
